import { Col, Row } from "react-bootstrap";
import Table from 'react-bootstrap/Table';
import useOrder from "../../../context/OrderContext";
import PricingComponent from "./PricingComponent";
import Productdesp from "./Productdesp";


const Extrainfo = () => {
  const { quoteData, orderForm } = useOrder();


  //Print Quote data


  return (
    <div className="extra-info">
      <div className="orderform-sidesection">
        <Row>
          <Col sm={12} md={12} lg={12} xl={12} xxl={12} ><Productdesp sizeLg /></Col>
        </Row>
        {/* <Row className="m-1"> */}
        {/* <fieldset style={{marginBottom:"6px",marginTop:"12px"}}>
            <label className="label-heading">Select the Quote Options</label>
            <div className="quote-list">
            {permission?.find(event => event.moduleId === 29)?.permissionType?.indexOf('Add') !== -1 ?
              <div className="RadioButton">
                <input value="Save as Quote" type="radio" name="quote" onClick={() => { validateaddSubmit("quote"); }} />
                <label>Save as Quote</label>
              </div>
              : 
              <div className="RadioButton">
              <input value="Save as Quote" type="radio" name="quote" disabled/>
              <label>Save as Quote</label>
            </div>
            }
            {permission?.find(event => event.moduleId === 29)?.permissionType?.indexOf('Add') !== -1 ?
              <div className="RadioButton">
                <input value="saveprint" type="radio" name="quote" onClick={handleQuotePrint}/>
                <label>Save & Print</label>
              </div>
              : <div className="RadioButton">
              <input value="saveprint" type="radio" name="quote" disabled/>
              <label>Save & Print</label>
            </div>}
            {permission?.find(event => event.moduleId === 29)?.permissionType?.indexOf('Add') !== -1 ?
              <div className="RadioButton">
                <input value="emailquote" type="radio" name="quote" onClick={emailQuotehandler}/>
                <label>Email Quote</label>
              </div>
              : <div className="RadioButton">
              <input value="emailquote" type="radio" name="quote" disabled/>
              <label>Email Quote</label>
            </div>}
            </div>
          </fieldset> */}
        {/* </Row> */}
      </div>
      {/* Quote List */}
      {orderForm === "Quote" && (
        <>
          {quoteData?.length > 0 ? <div className="orderform-sidesection mt-4">
            <h5>Quote List</h5>
            <div className="quote-table">
              <Table className="mt-3">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Quote No</th>
                  </tr>
                </thead>
                <tbody>
                  {quoteData?.length > 0 ? (

                    quoteData.map((data, index) => {

                      return (
                        <tr key={index}>
                          <td>{data?.quoteId}</td>
                          <td>{data?.quoteNo}</td>
                        </tr>
                      )
                    })

                  ) : (
                    <p>No data found </p>
                  )}
                </tbody>
              </Table>
            </div>
          </div> : ""}
        </>
      )}


      {/* Pricing section */}

      <>
        <>
          <div className="orderform-sidesection mt-4">
            <fieldset>
              <label className="label-heading">Pricing</label>
              <PricingComponent />
            </fieldset>
            {/* <fieldset>
                      <label className="label-heading">Fuel Surcharge</label>
                      <div className="btn-status">
                        <div className="form-floating">
                          <InputGroup.Text id="basic-addon1">$</InputGroup.Text>
                          <Form.Control type="text" placeholder="Fuel Surcharge" name="Fuelsurcharge" onChange={e => { Addresshandler(e); }}
                            className={`form-control ${touched.Fuelsurcharge && errors.Fuelsurcharge ? "is-invalid" : ""}`} required />
                          <label htmlFor="FuelSurcharge">Fuel Surcharge</label>
                          <ErrorMessage component="div" name="Fuelsurcharge" className="invalid-feedback" />
                        </div>
                      </div>
                    </fieldset> */}
            {/* <fieldset>
                      <label className="label-heading">Total price</label>
                      <div className="btn-status ">
                        <div className="form-floating">
                          <InputGroup.Text id="basic-addon1">$</InputGroup.Text>
                          <Form.Control type="text" placeholder="Total Price" name="Subtotal" onChange={e => { Addresshandler(e); handleBlur(e); handleChange(e) }}
                            className={`form-control ${touched.Subtotal && errors.Subtotal ? "is-invalid" : ""}`} required />
                          <label htmlFor="Subtotal">Sub Total</label>
                          <ErrorMessage component="div" name="Subtotal" className="invalid-feedback" />
                        </div>
                      </div>
                      <Form.Group as={Row} controlId="formHorizontalEmail">
                        <Row className="mt-2">
                          <Col sm={6} className="mb-2">
                            <FloatingLabel controlId="floatingInput" label="Tax Name">
                              <Form.Control type="text" placeholder="tax Name" name="Tax Name" required />
                            </FloatingLabel>
                          </Col>
                          <Col sm={6} className="mb-2">
                            <div className="btn-status" style={{ width: "148px" }}>
                              <div className="form-floating">
                                <InputGroup.Text id="basic-addon1">$</InputGroup.Text>
                                <Form.Control type="text" placeholder="Tax Amount" name="Taxamount" onChange={e => { Addresshandler(e); handleBlur(e); handleChange(e) }}
                                  className={`form-control ${touched.Taxamount && errors.Taxamount ? "is-invalid" : ""}`} required />
                                <label htmlFor="TotalPrice">Tax Amount</label>
                                <ErrorMessage component="div" name="Totalamount" className="invalid-feedback" />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form.Group>
                      <div className="btn-status ">
                        <div className="form-floating">
                          <InputGroup.Text id="basic-addon1">$</InputGroup.Text>
                          <Form.Control type="text" placeholder="Total Price" name="TotalPrice" onChange={e => { Addresshandler(e); handleBlur(e); handleChange(e) }}
                            className={`form-control ${touched.TotalPrice && errors.TotalPrice ? "is-invalid" : ""}`} required />
                          <label htmlFor="TotalPrice">Total Price</label>
                          <ErrorMessage component="div" name="TotalPrice" className="invalid-feedback" />
                        </div>
                      </div>
                    </fieldset> */}
          </div>
        </>
      </>


    </div>
  );
}
export default Extrainfo;